import { render, staticRenderFns } from "./clearable-editor.vue?vue&type=template&id=5534f7e5&scoped=true&"
import script from "./clearable-editor.vue?vue&type=script&lang=js&"
export * from "./clearable-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534f7e5",
  null
  
)

export default component.exports